import { useContentMeasuredStyles } from '@/features/ui/components/Dropdown/hooks/useContentMeasuredStyles'
import { useSetDismissOverlayCloseHandler } from '@/features/ui/components/Dropdown/hooks/useSetDismissOverlayCloseHandler'
import Content from '@/features/ui/components/Dropdown/parts/Content'
import { DropdownContentWidth, PreferredPosition } from '@/features/ui/components/Dropdown/types'
import { FC, ReactNode, useEffect, useRef } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { Gesture, GestureDetector } from 'react-native-gesture-handler'

interface DropdownProps {
    visible: boolean
    Anchor: ReactNode
    ItemList: ReactNode
    preferredPosition?: PreferredPosition
    contentWidth?: DropdownContentWidth
    onClose: () => void
    contentStyle?: StyleProp<ViewStyle>
    containerStyle?: StyleProp<ViewStyle>
}

const Dropdown: FC<DropdownProps> = ({
    visible,
    Anchor,
    ItemList,
    preferredPosition = 'below',
    contentWidth = 'anchor',
    onClose,
    contentStyle,
    containerStyle,
}) => {
    const anchorRef = useRef<View>(null)
    const contentRef = useRef<View>(null)

    const [measuredStyles, measureStyles] = useContentMeasuredStyles(
        anchorRef,
        contentRef,
        preferredPosition,
        contentWidth
    )

    useSetDismissOverlayCloseHandler(visible, onClose)

    useEffect(() => {
        if (!visible) return

        const frame = requestAnimationFrame(() => {
            void measureStyles()
        })

        return () => cancelAnimationFrame(frame)
    }, [measureStyles, visible])

    const tap = Gesture.Tap()

    return (
        <View style={containerStyle}>
            <GestureDetector gesture={tap}>
                <View collapsable={false} style={{ cursor: 'pointer' }} ref={anchorRef}>
                    {Anchor}
                </View>
            </GestureDetector>
            <Content
                visible={visible}
                measuredStyles={measuredStyles}
                onLayout={measureStyles}
                style={contentStyle}
                ref={contentRef}
            >
                {ItemList}
            </Content>
        </View>
    )
}

export default Dropdown
